import React, {ReactNode} from "react";
import {Stack, Tooltip, Typography} from "@mui/material";
import {StatFigure} from "../../components/visit-stat-block/OfficeVisitStats";
import {EmployeeVisitFigure} from "../employee-visit-report/EmployeeVisitReportFilter";

export function WidgetFigure({label, title, figure}: {
    label: string,
    title?: string,
    figure: ReactNode
}) {
    return (
        <Stack alignItems="flex-end" sx={{minWidth: 84}}>
            <Typography variant="caption" color="text.secondary" title={title}>{label}</Typography>
            <Typography variant="body2">{figure}</Typography>
        </Stack>
    );
}

export function WidgetStats({figure}: {
    figure: StatFigure,
}) {
    return (
        <>
            <Typography variant="body2" component="span" pr={1}>
                {figure.value}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="span">
                {figure.percent}%
            </Typography>
        </>
    );
}

export function WidgetEmployeeVisitFigure({employeeVisits}: {
    employeeVisits: EmployeeVisitFigure
}) {
    return (
        <Tooltip
            title={
                <Typography variant="body1">
                    {employeeVisits.workDayVisits} {employeeVisits.workDayVisits === 1 ? 'visit' : 'visits'} in {employeeVisits.tenureDayCount} days
                </Typography>
            }
            enterDelay={500}
        >
            <Typography variant="body2">
                {employeeVisits.workDayVisits} of {' '}
                <WidgetStats figure={{value: employeeVisits.tenureDayCount, percent: employeeVisits.percent}}/>
            </Typography>
        </Tooltip>
    );
}